import { useSelector } from 'react-redux';

import {
  getIsEventErvkCorrectionRequired,
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusRejected,
  getKnmWatchOnlyByTestUser,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { getIsPlanErknmStatusConsidered } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';

export const useIsEventsEnabled = () => {
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isKnmStatusFillInProcess = useSelector(getKnmIsErknmStatusFillInProcess);
  const isKnmStatusReadyForApprove = useSelector(getKnmIsErknmStatusReadyForApprove);
  const isEditableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const isKnmStatusRejected = useSelector(getKnmIsErknmStatusRejected);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const isEventsRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.EVENTS);
  const isKindKnmRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.KIND_KNM);
  const isDatesRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.DATES);
  const isReasonsRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.REASONS);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isEventErvkCorrectionRequired = useSelector(getIsEventErvkCorrectionRequired);
  const isWatchOnlyByTestUser = useSelector(getKnmWatchOnlyByTestUser);

  return (
    !isCommonWatchOnly &&
    !isWatchOnlyByTestUser &&
    isSupervisor &&
    (isKnmStatusFillInProcess ||
      isKnmStatusReadyForApprove ||
      isEditableInStatusCommentsExist ||
      isEventErvkCorrectionRequired ||
      (isKnmStatusRejected && isKnmPlanStatusConsidered) ||
      (isKnmStatusCommentsExist &&
        isKnmPlanStatusConsidered &&
        (isEventsRemarksExists || isKindKnmRemarksExists || isDatesRemarksExists || isReasonsRemarksExists)))
  );
};
